<template>
  <v-dialog transition="dialog-bottom-transition" persistent max-width="700">
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="light-blue ma-5" small dark v-bind="attrs" v-on="on"
        >{{ $t("AddNew") }}
      </v-btn>
    </template>
    <template v-slot:default="dialog">
      <v-card>
        <v-card-title class="light-blue darken-4 white--text">{{
          $t("string689")
        }}</v-card-title>
        <v-divider class="mb-8"></v-divider>
        <v-card-text>
          <component
            v-bind:is="currentTabComponent"
            class="tab"
            @changeEdit="
              () => {
                dialog.value = false;
                close();
              }
            "
            :editAccount="true"
            :country="country"
            :accountData="accountData"
          ></component>
        </v-card-text>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
import StripeUSComponent from "@/components/payouts/StripeUSComponent.vue";
import StripeJPComponent from "@/components/payouts/StripeJPComponent.vue";

export default {
  components: {
    StripeUSComponent,
    StripeJPComponent
  },
  props: ["country", "getConnectAccount"],
  data() {
    return {
      dialog: false,
      accountData: {
        firstName: null,
        lastName: null,
        accountNumber: null,
        abartn: null
      }
    };
  },
  computed: {
    currentTabComponent: function() {
      return "Stripe" + this.country + "Component";
    }
  },
  methods: {
    close() {
      this.getConnectAccount();
    }
  }
};
</script>

<style></style>
